var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GrFilterTrigger,{attrs:{"filters":_setup.filters},on:{"search":_setup.setSearchInFilter}},[_c(_setup.ButtonFilter,{attrs:{"img":_setup.search,"title":_vm.$t('opportunities.actions.filterSearch')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }